export const LIST_ITEMS_PER_PAGE_LIST = [50, 100, 150, 200];
